import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { QuizList } from '../../components/Quiz/QuizList';
import { ListControls } from '../../components/UI/ListControls';
import { clearError, setActiveFilter } from '../../redux/reducers/quizzes';
import { getQuizzes } from '../../redux/actions/quizzes';
import { getFilteredQuizzes } from '../../redux/selectors/quizzes';
import { utils } from '../../utils/helpers';
const ListQuizzesComponent = ({ quizzes, activeFilter, getQuizzes, clearError, setActiveFilter, }) => {
    const [layout, setLayout] = useState(() => utils.getLocalStorage('quiz-list-layout', 'List'));
    const [page, setPage] = useState(() => ({
        current: 1,
        size: utils.getLocalStorage('quiz-list-page-size', 5),
    }));
    const [visibleQuizzes, setVisibleQuizzes] = useState([]);
    useEffect(() => {
        if (quizzes.length <= 1)
            getQuizzes({});
        return () => {
            clearError();
        };
    }, []);
    useEffect(() => {
        const startIndex = (page.current - 1) * page.size;
        const endIndex = startIndex + page.size;
        const paginatedQuizzes = quizzes.slice(startIndex, endIndex);
        setVisibleQuizzes(paginatedQuizzes);
    }, [quizzes, page]);
    const updateLayout = (layout) => {
        const newPageSize = layout === 'Grid'
            ? quizzes.length
            : utils.getLocalStorage('quiz-list-page-size', 5);
        setPage({ current: 1, size: newPageSize });
        setLayout(layout);
        utils.setLocalStorage('quiz-list-layout', layout);
    };
    const updateFilter = ({ status, text, }) => {
        setActiveFilter({ status, text });
        setPage({ ...page, current: 1 });
    };
    const updatePage = ({ current, size }) => {
        setPage({ current, size });
        // Save page size to localStorage (but not for Grid layout which shows all items)
        if (layout !== 'Grid') {
            utils.setLocalStorage('quiz-list-page-size', size);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ListControls, { totalLength: quizzes.length, layout: layout, updateLayout: updateLayout, activeFilter: activeFilter, updateFilter: updateFilter, page: page, updatePage: updatePage }),
        React.createElement(QuizList, { quizzes: visibleQuizzes, layout: layout })));
};
/**
 * Maps Redux state to component props
 */
const mapStateToProps = (state) => ({
    quizzes: getFilteredQuizzes(state.quizState.quizzes, state.quizState.activeFilter),
    activeFilter: state.quizState.activeFilter,
    loading: state.quizState.loading,
    error: state.quizState.error,
    errorDetail: state.quizState.errorDetail,
});
/**
 * Redux action creators to be bound to component props
 */
const mapDispatchToProps = {
    getQuizzes,
    clearError,
    setActiveFilter,
};
export const ListQuizzes = connect(mapStateToProps, mapDispatchToProps)(ListQuizzesComponent);
